// extracted by mini-css-extract-plugin
export default {"container":"EndModal_container__33jOR","centered_text":"EndModal_centered_text__pzs3X","center_bttn":"EndModal_center_bttn__91Kcr"};